import env from 'env'

export default {
  featureFlags: {
    benefits_page: true,
  }
}
